<template>
  <div class="home-wrap">
    <div class="info-box">
      <div class="head-box">
        <img src="@/assets/img/images/coin-gct.png" />
        <div class="c-flex1 c-flex-column ml20">
          <p class="title-p">GCT Token</p>
          <div class="c-flex-space-between c-flex-align-center">
            <div>
              <div class="title-type">{{ $t("coin.type") }}</div>
              <div class="title-info">{{ $t("coin.typeInfo") }}</div>
            </div>
            <div class="c-flex">
              <div class="btn-blue">{{ $t("coin.btn1") }}</div>
              <div class="btn-blue ml20">{{ $t("coin.btn2") }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="tab-box">
        <div class="tab">
          <div :class="[{ sel: typeValue === 1 }]" @click="typeChange(1)">
            {{ $t("coin.tab1") }}
          </div>
          <div :class="[{ sel: typeValue === 2 }]" @click="typeChange(2)">
            {{ $t('coin.tab2') }}
          </div>
        </div>
        <div class="detail-box">
          <template v-if="typeValue === 1">
            <img src="@/assets/img/images/coin-gct-bj.jpg" />1111111111111111111111
			<img src="@/assets/img/images/coin-gct-bj-1.jpg" />
          </template>
          <template v-if="typeValue === 2">
            <div class="file-box">{{ $t('coin.tab2') }}</div>
          </template>
        </div>
      </div>
    </div>

    <VFooter />
    <QuestionPopup />
  </div>
</template>

<script>
import VFooter from "@/components/footer/VFooter";
import QuestionPopup from "@/components/QuestionPopup/index.vue";
export default {
  name: "GCTDetail",
  components: {
    VFooter,
    QuestionPopup
  },
  data() {
    return {
      typeValue: 1,
    };
  },
  methods: {
    typeChange(val) {
      this.typeValue = val;
    },
  },
};
</script>
<style lang="less" scoped>
.home-wrap {
  position: relative;
  background: #f5f6f7;
  .info-box {
    padding: 120px 260px 260px 260px;
    .head-box {
      height: 160px;
      padding: 20px;
      display: flex;
      background: #ffffff;
      border-radius: 12px 12px 12px 12px;
      img {
        width: 120px;
        height: 120px;
      }
      .title-p {
        font-family: PingFang SC, PingFang SC;
        font-weight: 800;
        font-size: 24px;
        color: #333333;
      }
      .title-type {
        height: 28px;
        padding: 0 8px;
        margin-top: 16px;
        width: fit-content;
        background: #e1eaff;
        border-radius: 4px 4px 4px 4px;
        line-height: 28px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #4063ff;
      }
      .title-info {
        margin-top: 16px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #999999;
      }
      .btn-blue {
        height: 52px;
        cursor: pointer;
        padding: 0 22px;
        line-height: 52px;
        border-radius: 8px 8px 8px 8px;
        border: 1px solid #4063ff;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 18px;
        color: #4063ff;
      }
    }

    .tab-box {
      overflow: hidden;
      background: #ffffff;
      margin-top: 28px;
      border-radius: 12px 12px 12px 12px;
      .tab {
        display: flex;
        border-bottom: 1px solid #e2e3e3;
        div {
          padding: 20px;
          cursor: pointer;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 16px;
          color: #333333;
        }
        .sel {
          font-weight: 800;
          color: #4063ff;
          position: relative;
        }
        .sel::before {
          content: "";
          position: absolute;
          display: block;
          left: 0;
          width: 100%;
          bottom: 0;
          border-bottom: 2px solid #4063ff;
        }
      }
      .detail-box {
        padding: 20px;
        img {
          object-fit: cover;
          width: 100%;
        }
        .file-box {
          height: 52px;
          padding: 0 20px;
          background: #f4f5f6;
          border-radius: 8px 8px 8px 8px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .title {
            gap: 32px;
            display: flex;
            img {
              width: 28px;
              height: 32px;
            }
            p {
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              font-size: 18px;
              color: #333333;
            }
          }
          .btn-box {
            gap: 20px;
            display: flex;
            .btn1 {
              width: 64px;
              height: 32px;
              cursor: pointer;
              line-height: 32px;
              text-align: center;
              background: #4b6dfe;
              border-radius: 4px 4px 4px 4px;
              border: 1px solid #4b6dfe;
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              font-size: 14px;
              color: #ffffff;
            }
            .btn2 {
              width: 64px;
              height: 32px;
              cursor: pointer;
              line-height: 32px;
              text-align: center;
              border-radius: 4px 4px 4px 4px;
              border: 1px solid #4b6dfe;
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              font-size: 14px;
              color: #4b6dfe;
            }
          }
        }
      }
    }
  }
}
</style>
